import { render, staticRenderFns } from "./favtrains.vue?vue&type=template&id=4557d586&scoped=true&"
import script from "./favtrains.vue?vue&type=script&lang=js&"
export * from "./favtrains.vue?vue&type=script&lang=js&"
import style0 from "./favtrains.vue?vue&type=style&index=0&id=4557d586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4557d586",
  null
  
)

export default component.exports